import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DefaultService } from '../../../utils/default.service';
import { ApiService } from '../../../shared/api.service';
import { TableSchema } from '../../../utils/table-schema';
import { CcassService } from '../../ccass.service';
import { SIDE_NAVE_TITLES } from '../../utils/util-constants';
import { MessageService } from 'primeng/api';
import { DataService } from '../../../data.service';
import { PrivilegeService } from '../../../shared/privilege.service';

@Component({
  selector: 'app-sales-person',
  templateUrl: './sales-person.component.html',
  styleUrls: ['./sales-person.component.scss']
})
export class SalesPersonComponent implements OnInit {

  pageTitle: string = SIDE_NAVE_TITLES.salesPerson;

  @Output() titleHeading = new EventEmitter<string>();
  @Output() shouldDisplayTitle = new EventEmitter<boolean>();

  tableColumns = TableSchema['sales-person'];
  loading = false;
  salespersonData: any = [];
  selectedRow: any;
  setDialogName: string;
  btnName: string;
  viewAddSalesPerson: boolean;
  headerSelectOptions: any = {}
  currentRow: any;
  onClickDelete: boolean;
  setIndex: any;
  showAlertPopup = false
  message: string;

  canAddSalesPerson = { 'screenName': 'CCASS', 'subModule': 'canAddSalesPerson' };


  constructor(
    private ccassService: CcassService,
    private apiService: ApiService,
    private defaultService: DefaultService,
    private messageService: MessageService,
    private dataService: DataService,
    public privilegeService: PrivilegeService,
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.titleHeading.emit(this.pageTitle);
    this.shouldDisplayTitle.emit(false);
    this.getSalespersonData()
  }

  getSalespersonData() {
    this.ccassService.ccassfindOne('', 'v1/salespersons').then(response => {
      if (response['status'] && response['status'] === 'success') {
        if(response['salesPersons'] && response['salesPersons'] !== null) {
          this.salespersonData = response['salesPersons'];
          this.setHeaderSelectOptions(response['salesPersons'])
        } else {
          this.salespersonData = []
          this.setHeaderSelectOptions([])
        }
      } else {
        this.messageService.add({ severity: 'error', detail: response['status'] });
        this.loading = false;
        // handle failure
      }
    }).catch(err => {
      if (err.status == 500) {
        this.messageService.add({ severity: 'error', detail: err['statusText'] ? err['statusText'] : 'Internal server error' });
      }
      else if (err.status == 502) {
        this.messageService.add({ severity: 'error', detail: err.status ? err.status + 'Bad Gateway' : '502 Bad Gateway' });
      } else {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
      this.loading = false;
      // handle error
    });
  }

  onAddSalesperson() {
    this.selectedRow = undefined;
    this.setDialogName = 'ADD';
    this.btnName = 'SAVE';
    this.viewAddSalesPerson = true;
  }

  setHeaderSelectOptions(data: any) {
    let nameOptions = [{ label: 'All', value: null }]
    let usernameOptions = [{ label: 'All', value: null }]
    if (data.length > 0) {
      data?.forEach((d: any) => {
        if (d.salespersonName) { nameOptions.push({ label: d.salespersonName, value: d.salespersonName }); }
        if (d.username) { usernameOptions.push({ label: d.username, value: d.username }); }
      })
      const uniqueFilenameOptions = [...new Set(nameOptions.map(item => item.label))];
      const uniqueUsernameOptions = [...new Set(usernameOptions.map(item => item.label))];
      nameOptions = []; usernameOptions = [];
      uniqueFilenameOptions?.forEach((element: any) => nameOptions.push({ label: element, value: element == 'All' ? null : element }));
      uniqueUsernameOptions?.forEach((element: any) => usernameOptions.push({ label: element, value: element == 'All' ? null : element }));
      this.headerSelectOptions['salespersonName'] = nameOptions;
      this.headerSelectOptions['username'] = usernameOptions;
      this.loading = false
    } else {
      this.headerSelectOptions['salespersonName'] = nameOptions;
      this.headerSelectOptions['username'] = usernameOptions;
      this.loading = false
    }
  }

  editSalesPerson(event: any) {
    this.selectedRow = event['row'];
    this.setDialogName = 'EDIT';
    this.btnName = 'UPDATE';
    this.viewAddSalesPerson = true;
  }

  deleteSalesPerson(event: any) {
    this.currentRow = event.row;
    this.onClickDelete = true;
    this.selectedRow = event.row;
    this.setIndex = event.index;
  }

  onClickYes() {
    const url = 'v1/salespersons/delete'
    this.ccassService.delete(this.selectedRow['id'], url).then(data => {
      if (data['status'] === 'success') {
        const message = data['message']
        this.shoeerrorpopup({message})
      } else {
        this.messageService.add({ severity: 'error', detail: data['message'] ? data['message'] : data['status'] });
        this.loading = false;
      }
    }).catch(err => {
      this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      this.loading = false;
    })
  }

  shoeerrorpopup(event:any) {
    this.showAlertPopup = true
    this.message = event.message
  }

  onClickok() {
    this.getSalespersonData()
  }

}
